import * as backend from '@/api/backend';
import { checkResponseStatus } from '@/util/check';

export default {
  state: {
    stripePackages: {
      bonusBookLimit: 1,
      couponsLimit: 30,
      description: [],
      design: null,
      distanceLimit: null,
      icon: '',
      id: 1,
      intervalTime: null,
      intervalType: null,
      isPromotion: 0,
      isSpecial: 0,
      name: 'Basic',
      packageBefore: null,
      packageID: 'basic',
      price: 0,
      specialDaysLimit: 2,
      specialsPerDay: 1,
      statistics: '[]',
      subscription: 1,
    },
    loading: false,
    error: false,
  },
  mutations: {
    fetchPackages(state) {
      state.loading = true;
    },
    errorPackages(state) {
      state.stripePackages = [];
      state.loading = false;
      state.error = true;
    },
    setPackages(state, stripePackages) {
      state.stripePackages = stripePackages;
      state.loading = false;
      state.error = false;
    },
  },
  actions: {
    async fetchPackages({ commit, rootState }, payload) {
      const id = payload?.companyID || rootState?.company?.companyEdit?.id;
      if (!id) return;

      commit('fetchPackages');
      try {
        const response = await backend.getStripeCompanyPackages(id);
        checkResponseStatus(200, response);
        const json = response.data;
        const stripePackages = json && json.packages ? json.packages : [];
        commit('setPackages', stripePackages);
      } catch (e) {
        console.error(e);
        commit('errorPackages');
      }
    },
  },

  namespaced: true,
};
